import { Tab } from './tab.js';
import { TabList } from './tab-list.js';
import { TabPanel } from './tab-panel.js';
import { Tabs as Tabs$1 } from './tabs.js';
import '@ariakit/react';
var Tabs = Object.assign(Tabs$1, {
  /**
   * The component that displays a Tab name and allows selection.
   */
  Tab: Tab,

  /**
   * Wrapper for a list of Tabs.
   */
  TabList: TabList,

  /**
   * The content for a single Tab.
   */
  TabPanel: TabPanel
});
export { Tabs };